import './DashbordBackOffice.scss';
import 'chart.piecelabel.js';

import EventOutlinedIcon from '@mui/icons-material/EventOutlined';
//import moment from 'moment';
import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { RdvIconDashboard } from '../../data/SVGs';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import useUtilities from '../../hooks/useUtilities';
import useWindowSize from '../../hooks/useWindowSize';
import { formatDateJJMMYYYY } from '../../Utils/dateFormatter';
import { adapter4BackendProxy } from '../../Utils/utilsDashboards';
import BoxesCountStatusCandidatures from './Dashbords/BoxesCountStatusCandidatures';
import StatutCras from './Dashbords/StatutCras';
import StatutMissions from './Dashbords/StatutMissions';
import TotalAo from './Dashbords/TotalAo';

export function filtreListPeriode(listBeforeFiltre,periode,customPeriode,dateField='dateAo'){
    let filteredData=[];
    const currentDate = new Date();
    const startOfWeek = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        currentDate.getDate() - currentDate.getDay()
    );
    const startOftwoPreviousWeek = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        currentDate.getDate() - 15
    );

    const startOfLastWeek = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        currentDate.getDate() - 7
    );
    const createdAt = dateField === 'createdAt' ? true : false;
    const updatedAt = dateField === 'updatedAt' ? true : false;

    console.log('startOfLastWeek',startOfLastWeek,'startOftwoPreviousWeek',startOftwoPreviousWeek);
    const startOfCurrentMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
    const startOfNextMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1);
    if(periode=='thisWeek')
        filteredData = listBeforeFiltre.filter(
            (item) => {
                if (createdAt) {
                    return new Date(item.createdAt) >= startOfWeek || new Date(item.createdAt) >= startOfLastWeek;
                } else if (updatedAt) {
                    return new Date(item.updatedAt) >= startOfWeek || new Date(item.updatedAt) >= startOfLastWeek;
                }
                else
                    return ((new Date(item.dateDebutAO) >= startOfWeek)||(new Date(item.dateDebutAO) >= startOfLastWeek));
            }
        );
    else if(periode=='twoPrevWeeks')
        filteredData = listBeforeFiltre.filter(
            (item) =>  {
                if (createdAt) {
                    return new Date(item.createdAt) >= startOfWeek || new Date(item.createdAt) >= startOftwoPreviousWeek;
                } else if (updatedAt) {
                    return new Date(item.updatedAt) >= startOfWeek || new Date(item.updatedAt) >= startOftwoPreviousWeek;
                }
                else{

                    return ((new Date(item.dateDebutAO) >= startOfWeek)||(new Date(item.dateDebutAO) >= startOftwoPreviousWeek));
                }
            }
        );
    else if (periode=='thisMonth')
        filteredData = listBeforeFiltre.filter(
            (item) => {
                if (createdAt) {
                    return new Date(new Date(item.createdAt).getFullYear(), new Date(item.createdAt).getMonth(), 1) >= startOfCurrentMonth && new Date(new Date(item.createdAt).getFullYear(), new Date(item.createdAt).getMonth(), 1) < startOfNextMonth;
                } else if (updatedAt) {
                    return new Date(new Date(item.updatedAt).getFullYear(), new Date(item.updatedAt).getMonth(), 1) >= startOfCurrentMonth && new Date(new Date(item.updatedAt).getFullYear(), new Date(item.updatedAt).getMonth(), 1) < startOfNextMonth;
                }
                else{
                    return (new Date(new Date(item.dateDebutAO).getFullYear(),new Date(item.dateDebutAO).getMonth(),1)>= startOfCurrentMonth  && (new Date(new Date(item.dateDebutAO).getFullYear(),new Date(item.dateDebutAO).getMonth(),1)<startOfNextMonth));
                }
            }
        );
    else if (periode=='custom' && customPeriode){
        console.log('customDateRangeAos',customPeriode,'from',customPeriode['from'],'to',new Date(new Date(customPeriode['to']).getFullYear(),new Date(customPeriode['to']).getMonth(),1));
        filteredData = listBeforeFiltre.filter(
            (item) => {
                if (createdAt) {
                    return new Date(new Date(item.createdAt).getFullYear(), new Date(item.createdAt).getMonth(), 1) >= new Date(new Date(customPeriode['from']).getFullYear(), new Date(customPeriode['from']).getMonth(), 1) && new Date(new Date(item.createdAt).getFullYear(), new Date(item.createdAt).getMonth(), 1) <= new Date(new Date(customPeriode['to']).getFullYear(), new Date(customPeriode['to']).getMonth(), 1);
                } else if (updatedAt) {
                    return new Date(new Date(item.updatedAt).getFullYear(), new Date(item.updatedAt).getMonth(), 1) >= new Date(new Date(customPeriode['from']).getFullYear(), new Date(customPeriode['from']).getMonth(), 1) && new Date(new Date(item.updatedAt).getFullYear(), new Date(item.updatedAt).getMonth(), 1) <= new Date(new Date(customPeriode['to']).getFullYear(), new Date(customPeriode['to']).getMonth(), 1);
                }
                else{
                    return ((new Date(new Date(item.dateDebutAO).getFullYear(),new Date(item.dateDebutAO).getMonth(),1) >= new Date(new Date(customPeriode['from']).getFullYear(),new Date(customPeriode['from']).getMonth(),1)) && (new Date(new Date(item.dateDebutAO).getFullYear(),new Date(item.dateDebutAO).getMonth(),1) <= new Date(new Date(customPeriode['to']).getFullYear(),new Date(customPeriode['to']).getMonth(),1)));
                }
            }
        );
    }

    return filteredData;
}

export function parseDate(dateString) {
    console.log('dateString',dateString);
    if(dateString!=null){
        const [month, year] = dateString.split('-');
        console.log('month',month,'parsDate',new Date(parseInt(year), parseInt(month)-1, 1));
        return new Date(parseInt(year), parseInt(month)-1, 1);
    }
}

export function filtreListPeriodeMonthYear(listBeforeFiltre,periode,customPeriode){
    let filteredData=[];
    const currentDate = new Date();

    const startOfCurrentMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
    const startOfNextMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1);
    console.log('listBeforeFiltre',listBeforeFiltre);

    if (periode=='thisMonth')
        filteredData = listBeforeFiltre.filter(
            (item) => (parseDate(item.dateDebutAO) >= startOfCurrentMonth && parseDate(item.dateDebutAO) < startOfNextMonth )
        );
    else if (periode=='custom' && customPeriode){
        console.log('customDateRangeAos',customPeriode,'from',new Date(new Date(customPeriode['from']).getFullYear(),new Date(customPeriode['from']).getMonth(),1),'to',new Date(new Date(customPeriode['to']).getFullYear(),new Date(customPeriode['to']).getMonth(),1),'dateAo');
        filteredData = listBeforeFiltre.filter(
            (item) => ((parseDate(item.dateDebutAO) >= new Date(new Date(customPeriode['from']).getFullYear(),new Date(customPeriode['from']).getMonth(),1)) && (parseDate(item.dateDebutAO) <= new Date(new Date(customPeriode['to']).getFullYear(),new Date(customPeriode['to']).getMonth(),1)))
        );
    }
    console.log('listBeforeFiltre after',filteredData);

    return filteredData;
}

function DashbordBackOffice() {

    const axiosPrivate = useAxiosPrivate();
    const [DataForCandidatureRecuParAO, SetDataForCandidatureRecuParAO] = useState();
    //const [dataAllAos, SetDataAllAos]=useState();
    const { i18n } = useTranslation();
    //const [selectedStatutPaiementCaffaireCR, setSelectedStatutPaiementCaffaireCR] = useState('all'); // Default selected period
    const [selectedClient, setSelectedClient] = useState([]); // Default selected Client
    //const [chartDataCaByCr, setChartDataCaByCr] = useState({
    //    series: [],

    //    options: {
    //        labels: [],
    //        chart: {
    //            type: 'bar',
    //            //stackType: '50%',
    //            //toolbar: {
    //            //    show: true
    //            //},
    //            zoom: {
    //                enabled: true,
    //                //type: 'xy', // Use 'xy' for 2D zoom (x and y-axis) or 'y' for only y-axis zoom
    //            },
    //        },
    //        bar : {
    //            columnWidth: '50px',
    //        },
    //        plotOptions: {
    //            bar: {
    //                horizontal: false,
    //                //distributed: true, // this line is mandatory
    //                columnWidth: '15%', // Set the desired bar width as a percentage of the available space
    //            }
    //        },
    //        dataLabels: {
    //            enabled: false
    //        },
    //        //plotOptions: {
    //        //    bar: {
    //        //        horizontal: false,
    //        //        columnWidth: '10%', // Adjust the width of the bars here
    //        //        dataLabels: {
    //        //            enabled: false, // Set this to false to hide data labels
    //        //        },
    //        //    },
    //        //},

    //        legend: {
    //            position: 'bottom',
    //            offsetY: 40
    //        },
    //        fill: {
    //            opacity: 1,
    //        },
    //    },
    //});

    const [chiffreAffaire,setChiffreAffaire]=useState();
    //const [selectedClientCheckBoxCR, setSelectedClientCheckBoxCR] = useState(['all']);
    const [statusCandiaturesByCompanyId,setAllStatusCandiaturesByCompanyId]= useState();
    const [allStatusMissions,setAllStatusMissions]= useState();
    const [allCras,setAllCras]= useState();
    //const [allFactures,setAllFactures]=useState();
    //const [selectedBackOffice,setSelectedBackOffice]=useState('all');
    const [rdvsList,setRdvsList]=useState();
    const {device}=useWindowSize();

    useEffect(() =>{
        getDataForCandidatureRecuParAO();
    }, []);

    const getDataForCandidatureRecuParAO = async () => {
        try {
            // const response1 = await fetch(API_URI_CVTheque + 'getStatistics/'+ encodeURIComponent(temp), {
            //     method: 'Get',
            // });

            //const [allCandidatures,totalAos,allStatusCandiatures, allMissions,cras,factures,chiffreAffaire,rdvs,trafics]

            //const allStatusCandiatures = await adapter4BackendProxy(axiosPrivate, 'admin/getStatusCandidatures');
            //const allCandidatures=await adapter4BackendProxy(axiosPrivate, 'admin/getTotalCandidatures');
            //const rdvs=await adapter4BackendProxy(axiosPrivate, 'admin/getRdvs');
            //const allMissions=await adapter4BackendProxy(axiosPrivate, 'admin/getMissions');
            //const cras=await adapter4BackendProxy(axiosPrivate, 'admin/getCrasX');
            //const chiffreAffaire=await adapter4BackendProxy(axiosPrivate, 'admin/getCA');
            setBackdropOpen(true);
            const [allStatusCandiatures, allCandidatures, rdvs, allMissions, cras, chiffreAffaire] = await Promise.all([
                adapter4BackendProxy(axiosPrivate, 'admin/getStatusCandidatures').catch(error => {
                    console.error('Error fetching status candidatures:', error);
                    return [];
                }),
                adapter4BackendProxy(axiosPrivate, 'admin/getTotalCandidatures').catch(error => {
                    console.error('Error fetching total candidatures:', error);
                    return [];
                }),
                adapter4BackendProxy(axiosPrivate, 'admin/getRdvs').catch(error => {
                    console.error('Error fetching rdvs:', error);
                    return [];
                }),
                adapter4BackendProxy(axiosPrivate, 'admin/getMissions').catch(error => {
                    console.error('Error fetching missions:', error);
                    return [];
                }),
                adapter4BackendProxy(axiosPrivate, 'admin/getCrasX').catch(error => {
                    console.error('Error fetching CrasX:', error);
                    return [];
                }),
                adapter4BackendProxy(axiosPrivate, 'admin/getCA').catch(error => {
                    console.error('Error fetching CA:', error);
                    return [];
                })
            ]);

            setRdvsList(rdvs);
            SetDataForCandidatureRecuParAO(allCandidatures);
            setAllStatusMissions(allMissions);
            setAllCras(cras);
            setAllStatusCandiaturesByCompanyId(allStatusCandiatures);
            setChiffreAffaire(chiffreAffaire);
            setBackdropOpen(false);

        } catch (error) {
            console.log(error.response?.status);
        }
    };

    //const groupData = (data,filtreItem) => {
    //    let key2;
    //    const groupedData = data.reduce((result, item) => {
    //        const { periode, totalHtClient } = item;
    //        if (filtreItem === 'backOffice') {
    //            key2 = item.backOfficeId;
    //        } else {
    //            key2 = item.statutPaiementCalculated;
    //        }

    //        if (!result[periode]) {
    //            result[periode] = {};
    //        }
    //        if (!result[periode][key2]) {
    //            result[periode][key2] = 0;
    //        }
    //        result[periode][key2] += totalHtClient;
    //        return result;
    //    }, {});
    //    console.log('groupedData',groupedData);
    //    return groupedData;
    //};

    //const calculateCAByPeriodeByCr = (data,selectedBO) => {
    //    var selectBOWithoutLastValue=selectedBO.slice(0, -1);
    //    const groupedData = groupData(data,'backOffice');
    //    // Construct the final arrays for each periode
    //    const periodes = Object.keys(groupedData);
    //    const backofficeArrays = selectBOWithoutLastValue.map(({ value }) =>
    //        periodes.map((periode) => groupedData[periode][value] || 0)
    //    );
    //    console.log('selectedBackOffice',selectBOWithoutLastValue);
    //    console.log('periodes',periodes);
    //    console.log('backofficeArrays',backofficeArrays);
    //    return {periodes,backofficeArrays,selectBOWithoutLastValue};
    //};

    //const [selectedBackOfficeValues, setSelectedBackOfficeValues] = useState([]);

    //const getAllBackOffice = async () => {
    //    try {
    //        const listBo=await adapter4BackendProxy(axiosPrivate,  'getAllListBackOffice');
    //        setSelectedBackOfficeValues(listBo);
    //    } catch (error) {
    //        console.log(error.response?.status);
    //    }
    //};
    //const statutPaiement = [
    //    {
    //        label:'Payé',
    //        value:'paye',

    //    },
    //    {
    //        label:'Non payé',
    //        value:'nonPaye'
    //    },
    //    {label:'Tout',value:'all'}
    //];

    //useEffect(()=>{
    //    if(Array.isArray(chiffreAffaire)){
    //        //const firstFiltrePeriode=filtreListPeriode(allStatusMissions,selectedPeriodMission,customDateRangeMission);
    //        var filteredData;
    //        filteredData=chiffreAffaire;
    //        //if (!selectedStatutPaiementCaffaireCR.includes('all')) {
    //        //    filteredData = chiffreAffaire.filter(
    //        //        (item) => selectedStatutPaiementCaffaireCR.includes(item.companyDataId)
    //        //    );
    //        //}
    //        //else
    //        //    filteredData=chiffreAffaire;
    //        //console.log('firt f margeNet Brute',filteredData);
    //        //if (selectedStatutPaiementCaffaireCR != 'all') {
    //        //    filteredData = filteredData.filter(
    //        //        (item) => item.statutPaimentClient == selectedStatutPaiementCaffaireCR
    //        //    );
    //        //}

    //        //if (selectedBackOffice != 'all') {
    //        //    filteredData = filteredData.filter(
    //        //        (item) => item.backOfficeId == selectedBackOffice
    //        //    );
    //        //}

    //        console.log('second f margeNet Brute',filteredData);
    //        const {periodes,backofficeArrays,selectBOWithoutLastValue}=calculateCAByPeriodeByCr(filteredData,selectedBackOfficeValues);
    //        console.log('ListBackOfficeIdsWithoutlALlval',selectBOWithoutLastValue);

    //        setChartDataCaByCr((prevState) => {
    //            return {
    //                ...prevState,

    //                series:selectBOWithoutLastValue.map((office, index) => ({
    //                    name: office.label,
    //                    data: backofficeArrays[index],
    //                })),
    //                options: {
    //                    ...prevState.options,
    //                    xaxis: {
    //                        ...prevState.options.xaxis,
    //                        categories: periodes
    //                        //Object.keys(counts)
    //                        //Array.isArray(CountsListStatusCandidatures) ? CountsListStatusCandidatures.map((item) => item.date) : [],
    //                    },
    //                },
    //            };
    //        });
    //    }
    //},[selectedClient,chiffreAffaire]);

    useEffect(()=>{
        getAllClient();
        //getAllBackOffice();
    },[]);

    //const { inputSize } = useWindowSize();
    const { setBackdropOpen} = useUtilities();
    const getAllClient = async () => {
        try {
            // const response2 = await fetch(API_URI_CVTheque + 'getAllListClient', {
            //     method: 'Get',
            // });
            setBackdropOpen(true);
            const clientList = await adapter4BackendProxy(axiosPrivate,   'getAllListClient');
            clientList.push({_id: 'all',value:'all', label: 'Tous les clients'});
            console.log(Array.isArray(clientList));
            setSelectedClient(clientList);
            setBackdropOpen(false);
        } catch (error) {
            console.log(error.response?.status);
        }
    };

    return (
        <div className='HomeFrame'>
            <h4 className='dashFrame13'>{i18n.t('Tableau de bord')}</h4>
            <BoxesCountStatusCandidatures
                statusCandiaturesByCompanyId={statusCandiaturesByCompanyId}
                DataForCandidatureRecuParAO={DataForCandidatureRecuParAO}
                allCras={allCras}
                chiffreAffaire={chiffreAffaire}
                allStatusMissions={allStatusMissions}
                backOffice={true}
            />

            <TotalAo
                selectedClient={selectedClient}
                dataAllAos={DataForCandidatureRecuParAO}
                filtreClient={true}
                width={'100%'}
                height={device=='desktop'?'425px':'auto'}
            />

            <div style={{display:'flex',flexDirection:device=='desktop'?'row':'column',gap:'24px',width:'100%',height:device=='desktop'?'425px':'auto'}}>
                <StatutMissions
                    allStatusMissions={allStatusMissions}
                    selectedClient={selectedClient}
                    filtreClient={true}
                    width={device=='desktop'?'50%':'100%'}
                    height={device=='desktop'?'425px':'auto'}
                />

                <StatutCras
                    allCras={allCras}
                    filtreClient={true}
                    role={'admin'}
                    width={device=='desktop'?'50%':'100%'}
                    height={device=='desktop'?'425px':'auto'}
                />
            </div>
            <div className='dashFrame6'>
                <div className='dashFrame7'>
                    <EventOutlinedIcon/>
                    <p className='dashFrame8'>
                        {i18n.t('Rendez vous à venir')}
                    </p>
                </div>
            </div>
            <div className='dashFrame9'>
                <div className='dashFrame10'>
                    <RdvIconDashboard/>

                    {Array.isArray(rdvsList) && rdvsList.length > 0 ? (
                        rdvsList.map((rdv, index) => (
                            <div
                                key={index}
                                className='dashFrame11'
                            >
                                <EventOutlinedIcon />
                                <p className='dashFrame12'>{formatDateJJMMYYYY(rdv.date)} à {rdv.heureDebut}</p>
                            </div>
                        ))
                    ) : (
                        <div className='dashFrame11'>
                            <EventOutlinedIcon />
                            <p className='dashFrame12'>{i18n.t('Aucun rendez vous pour le moment')}</p>
                        </div>

                    )}

                </div>

            </div>

        </div>
    );
}

export default DashbordBackOffice;